import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/services/api.service";
import { CategoryItem } from "src/app/types/category";
import { TagItem } from "src/app/types/tag";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class BlogListingDataService implements Resolve<any> {
  amountPerPage: number = 6;
  selectedCategory: CategoryItem;
  selectedTag: TagItem;

  constructor(private API: ApiService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    let categorySlug: string = route.paramMap.get("categorySlug");
    if (categorySlug) {
      this.selectedCategory = {
        slug: categorySlug,
      };
    } else {
      this.selectedCategory = null;
    }

    let tagSlug: string = route.paramMap.get("tagSlug");
    if (tagSlug) {
      this.selectedTag = {
        slug: tagSlug,
      };
    } else {
      this.selectedTag = null;
    }

    return this.API.GET(
      `public/blogs/${environment.mall_id}?featured=1&amount=${
        this.amountPerPage
      }${
        this.selectedCategory ? "&category=" + this.selectedCategory.slug : ""
      }${this.selectedTag ? "&tag=" + this.selectedTag.slug : ""}`
    ).pipe(
      catchError((error) => {
        this.router.navigate(["/"]);
        return of(null);
      })
    );
  }
}
